import {
    isKnownOrCountry,
    ENTITY_PART_TYPE_SEPARATOR,
} from '../../../models/common/EntityPart';
import { STS_PREFIX } from '../../../models/LocationPart';
import { mapHyphenSeparator } from '../../../services/hyphenSeparatorService';

const LocationFormatter = ({ node, value }) => {
    if (node && node.group) {
        return '';
    }

    if (!value) {
        return '';
    }

    if (value.partType === ENTITY_PART_TYPE_SEPARATOR) {
        return mapHyphenSeparator(value.value);
    }

    // Custom locationParts will have the string in the value.
    const upperDisplayName = value.displayName?.toUpperCase();
    return isKnownOrCountry(value.partType)
        ? value.isSTS &&
          upperDisplayName &&
          !upperDisplayName.startsWith(STS_PREFIX)
            ? `${STS_PREFIX}${upperDisplayName}`
            : upperDisplayName
        : value.value;
};

export default LocationFormatter;
